import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

interface MerchantPassiveReason {
  description: string;
  [key: string]: any;
}

type MerchantPassiveReasonsResponse = BaseResponse<MerchantPassiveReason[]>;

async function getMerchantPassiveReasons(): Promise<MerchantPassiveReasonsResponse> {
  try {
    const response = await axiosInstance.get("/Merchant/GetMerchantPassiveReasons");
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantPassiveReasons() {
  return useQuery<MerchantPassiveReasonsResponse | undefined, Error>(
    [QueryKeys.GetMerchantPassiveReasons], 
    () => getMerchantPassiveReasons()
  );
}